import {
  Component,
  OnInit,
  HostListener,
  SecurityContext,
} from '@angular/core';
import { NavigationService } from 'src/app/shared/microservices/navigation.service';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { DomSanitizer } from '@angular/platform-browser';
import { B2CUserAccountService } from 'src/app/shared/microservices/b2cuseraccount.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css'],
    standalone: false
})
export class HeaderComponent implements OnInit {
  config = environment.apiEndPoints;
  refereeRegistrationUrl = this.config.refreeRegistration;
  wholegamesystemUrl = this.config.wholeGameSystem;
  currentLink: any;
  targetLink: any;
  data: any = {
    HeaderHtml: String,
  };
  refreeRefData: any;
  isHeaderApiDone: boolean = false;
  isRefereeApiDone: boolean = false;
  menuactive: boolean = false;
  htmlContent: any = {
    mobileContent:
      '<header class="fa-navigation__header style="background-color:purple"><div class="container"><div class="logo-container"><a href="//www.thefa.com/" class="fa-logo"><img class="fa-logo__image" src="//cdn.thefa.com/thefawebsite/assets/images/the-fa-logo.svg" alt="The FA"></a><a href="#main-content" class="skiptocontent" tabindex="1">skip to main content</a></div><div class="mobile-controls"><div class="mobile-controls__items signin-menu logoutWidth"><span class="mobile-controls__item"><a class="mobile-controls__control-button sign-in-link logoutLink" id="logOut" role="link" aria-label="Logout link" tabindex="0"><span class="mobileLogout">Logout</span></a></span><li class="mobile-controls__item"><button type="button" class="mobile-controls__control-button menu-icon"><span>Menu</span></button></li></div></div></div></header>',
    subHeader:
      '<nav class="global-navigation container"  aria-label="My Account"><ul class="global-navigation__primary-menu menu-container primary-menu"><li class="global-navigation__primary-list-item primary-list-item"><a tabindex="0"class="global-navigation__primary-link global-navigation__link primary-link" id="my-account-header"href="#account-management/profile" routerLink="account-management/profile"><span class="text"id="profile" routerLink="account-management/profile">My Account </span></a></li><li class="global-navigation__primary-list-item primary-list-item"data-sectionpath="/sitecore/content/The-FA/www-thefa-com/home/competitions"><a tabindex="0"class="global-navigation__primary-link global-navigation__link primary-link"href="#account-management/dbs-safeguarding" routerLink="account-management/dbs-safeguarding"><span class="text" id="dbs-safeguarding"routerLink="account-management/dbs-safeguarding">Safeguarding </span></a></li><li class="global-navigation__primary-list-item primary-list-item"data-sectionpath="/sitecore/content/The-FA/www-thefa-com/home/competitions"><a tabindex="0"class="global-navigation__primary-link global-navigation__link primary-link"href="#account-management/learning" routerLink="account-management/learning"><span class="text"id="learning" routerLink="account-management/learning">Learning </span></a></li><li class="global-navigation__primary-list-item primary-list-item"data-sectionpath="/sitecore/content/The-FA/www-thefa-com/home/competitions"><a tabindex="0"class="global-navigation__primary-link global-navigation__link primary-link"href="#account-management/preferences" routerLink="account-management/preferences"><span class="text" id="preferences" routerLink="account-management/preferences">Preferences</span></a></li><li class="global-navigation__primary-list-item primary-list-item"><a tabindex="0"class="global-navigation__primary-link global-navigation__link primary-link"id="diversity-inclusion-header"href="#account-management/diversityAndInclusion?callingApp=my-account"routerLink="account-management/diversityAndInclusion/diversity?callingApp=my-account"><span class="text" id="diversityAndInclusion"routerLink="account-management/diversityAndInclusion/diversity?callingApp=my-account"> Diversity and Inclusion </span></a></li><li class="global-navigation__primary-list-item primary-list-item"data-sectionpath="/sitecore/content/The-FA/www-thefa-com/home/competitions"><a tabindex="0"class="global-navigation__primary-link global-navigation__link primary-link"href="#account-management/settings" routerLink="account-management/settings"><span class="text" id="settings" routerLink="account-management/settings">Settings</span></a></li></ul></nav>',
    logout:
      '<ul class="topbar__extramenu signin-menu"><li class="topbar__extra-item"><a role="link" tabindex="0" class="topbar__link sign-in-link" id="logOut">Logout</a></li></ul>',
  };
  bentoboxHTMl!: string;
  bentoboxMobileHTMl!: string;
  @HostListener('document:click', ['$event'])
  clickout(event: { target: any }) {
    if (
      $(event.target).is('#diversityAndInclusion') === false &&
      $(event.target).find('span').is('#preferences') === false &&
      $('#diversityAndInclusionToolTip').is(':visible') === true
    ) {
      $('#diversityAndInclusionToolTip').hide();
    }
    if (
      $(event.target).is('#preferences') === false &&
      $(event.target).find('span').is('#preferences') === false &&
      $('#preferenceToolTip').is(':visible') === true
    ) {
      $('#preferenceToolTip').hide();
    }
    if (
      $(event.target).is('#settings') === false &&
      $(event.target).find('span').is('#settings') === false &&
      $('#changePassToolTip').is(':visible') === true
    ) {
      $('#changePassToolTip').hide();
    }
  }
  constructor(
    private headerfooterService: NavigationService,
    private router: Router,
    private sanitizer: DomSanitizer,
    private b2CUserAccountService: B2CUserAccountService,
  ) {}

  ngOnInit() {
    this.bentoboxHTMl =
      '<li class="topbar__menu-item bentobox" ><a tabindex="0" role="button" title="combo box" class="topbar__link bento-content" aria-expanded="false" id="wholeGameSystem">Apps</a><div class="bentomenu" style="display: none;"><ul class="topbar__submenu-list-items"><li class="topbar__submenu-list-item" id="refRefDesktop"><a href="' +
      this.refereeRegistrationUrl +
      '" tabindex="0" class="topbar__submenu-link" style="color: rgb(255, 255, 255); text-decoration: none;" aria-label="Referee Registraion">REFEREE REGISTRATION</a></li></ul></div></li>';
    this.bentoboxMobileHTMl =
      '<li class="topbar__menu-item mobileShow" id="refrereg"><a tabindex="0"  class="topbar__link" href="' +
      this.refereeRegistrationUrl +
      '"" title="external link" aria-label="Referee Registraion">REFEREE REGISTRATION</a></li>';
    const callback = (response: any) => {
      this.data = response;
      this.isHeaderApiDone = true;
      if (this.isRefereeApiDone) {
        this.onApiResponse();
      }
    };
    this.headerfooterService.getHeaderFooterContent(callback.bind(this));
    let refreregAPi = this.headerfooterService.verifyRefreeRegistration();
    refreregAPi.subscribe(
      (res) => {
        this.refreeRefData = res;
        this.isRefereeApiDone = true;
        if (this.isHeaderApiDone) {
          this.onApiResponse();
        }
      },
      () => {
        this.refreeRefData = null;
        this.isRefereeApiDone = true;
        if (this.isHeaderApiDone) {
          this.onApiResponse();
        }
      }
    );
  }  

  onApiResponse() {

    this.data.HeaderHtml = this.data.HeaderHtml.replace(/href="#"/g, '');
    const css: any = document
      .createRange()
      .createContextualFragment(this.data['CssUrl']);
    document.head.appendChild(css);

    const scripts = document
      .createRange()
      .createContextualFragment(this.data['JavaScriptUrl']);
    document.head.appendChild(scripts);
    var that = this;

    setTimeout(function () {
      that.addEvents();
      let tempRoute = that.sanitizer.sanitize(
        SecurityContext.HTML,
        that.router.url.split('account-management/')[1]
      );
      let currentRoute = tempRoute && tempRoute.split('?')[0];
      let temp = currentRoute && currentRoute.split('/');
      let highlightLink = null;
      if (temp && temp.length > 1) {
        highlightLink = temp[0];
      } else {
        highlightLink = currentRoute;
      }
      $('.fa-navigation .global-navigation__primary-list-item').removeClass(
        'current-section'
      );
      $('.fa-navigation .global-navigation__primary-list-item').removeAttr(
        'aria-current'
      );
      $('#' + highlightLink)
        .closest('li.global-navigation__primary-list-item')
        .addClass('current-section');
      $('#' + highlightLink)
        .closest('li.global-navigation__primary-list-item')
        .attr('aria-current', 'page');
      $('ul.topbar__extramenu.signin-menu').remove();
      $(that.htmlContent.logout).insertAfter($('.topbar__permalinks'));
      if (window.screen.width > 768) {
        that.handleKeyboardEvents();
      }
      
      if (
        !document.getElementById('wholeGameSystem') &&
        that.refreeRefData.showRefRegLink
      ) {
        
        $('.topbar__permalinks').prepend(that.bentoboxHTMl);
        $('.topbar__menu-item.bentobox:first-child').after(
          that.bentoboxMobileHTMl
        );
        $('.fa-navigation .topbar').css('background-color', '#212121');

        that.addBentoEvents();
        var label = document.getElementsByClassName('fa-logo');
        label[0].setAttribute('aria-label', 'The FA link');
        var menuItem = document.getElementsByClassName('menu-icon');
        menuItem[0].setAttribute('aria-expanded', 'false');
      }
      /* Once all the headers are loaded, then the first link of the page is focused */
      document.getElementById('wholeGameSystem')?.focus();   
    }, 1000);
  }

  handleKeyboardEvents() {
    var that = this;
    // Enter action on logout link
    $('.sign-in-link').on({
      keyup: function (event) {
        if (event.key == 'Enter') {
          that.router.navigateByUrl('/logout');
        }
      },
    });
    // Tab action on logout link
    $('.sign-in-link').on({
      focusout: function () {
        document.getElementById('my-account-header')?.focus();
      },
    });
    // Tab action on last tab - diversity and inclusion tab
    $(
      '.global-navigation__primary-list-item.primary-list-item:last-child a'
    ).on({
      focusout: function () {
        $('.first-item-focus').trigger('focus');
      },
    });
  }

  addBentoEvents() {
    var that = this;
    let k: any = document.getElementsByClassName('topbar__menu-item bentobox');
    
    let expandAria: any = document.getElementById('wholeGameSystem');
    $('.topbar__link.bento-content').on({
      click: function (e) {
        k = document.getElementsByClassName('bentomenu');
        if (k['0'].style.display == 'none' || k['0'].style.display == '') {
          $('.fa-navigation .bentomenu').css('display', 'block');
          expandAria.setAttribute('aria-expanded', 'true');
          $('.fa-navigation .bentomenu .topbar__submenu-list-items').css(
            'display',
            'block'
          );
          $('.topbar__link.bento-content')
            .parent()
            .children()
            .on(
              'mouseenter mouseleave',
              function () {
                $('.fa-navigation .bentomenu .topbar__submenu-list-items').css(
                  'display',
                  'block'
                );
              },
              function () {
                $('.fa-navigation .topbar__submenu').css('display', 'none');
              }
            );
        } else {
          $('.fa-navigation .bentomenu').css('display', 'none');
          $('.fa-navigation .bentomenu .topbar__submenu-list-items').css(
            'display',
            'none'
          );
          expandAria.setAttribute('aria-expanded', 'false');
          $('.topbar__link.bento-content')
            .parent()
            .children()
            .on(
              'mouseenter mouseleave',
              function () {
                $('.fa-navigation .bentomenu .topbar__submenu-list-items').css(
                  'display',
                  'none'
                );
              },
              function () {
                $('.fa-navigation .topbar__submenu').css('display', 'none');
              }
            );
        }
        e.stopPropagation();
      },
      keydown: function (e) {
        if (e.key == 'Enter') {
          k = document.getElementsByClassName('bentomenu');
          if (k['0'].style.display == 'none' || k['0'].style.display == '') {
            $('.fa-navigation .bentomenu').css('display', 'block');
            expandAria.setAttribute('aria-expanded', 'true');
            $('.fa-navigation .bentomenu .topbar__submenu-list-items').css(
              'display',
              'block'
            );
            $('.topbar__link.bento-content')
              .parent()
              .children()
              .on(
                'mouseenter mouseleave',
                that.setSubMenuStyle.bind(this, 'block'),

                function () {
                  $('.fa-navigation .topbar__submenu').css('display', 'none');
                }
              );
          } else {
            $('.fa-navigation .bentomenu').css('display', 'none');
            expandAria.setAttribute('aria-expanded', 'false');
            $('.fa-navigation .bentomenu .topbar__submenu-list-items').css(
              'display',
              'none'
            );
            $('.topbar__link.bento-content')
              .parent()
              .children()
              .on(
                'mouseenter mouseleave',
                that.setSubMenuStyle.bind(this, 'none'),

                function () {
                  $('.fa-navigation .topbar__submenu').css('display', 'none');
                }
              );
          }
        }
      },
    });

    $(document).on('click', function (e) {
      if ($(e.target).is('.fa-navigation .bentomenu') === false) {
        k = document.getElementsByClassName('bentomenu');
        if (k['0'].style.display == 'block') {
          $('.fa-navigation .bentomenu').css('display', 'none');
          $('.fa-navigation .bentomenu .topbar__submenu-list-items').css(
            'display',
            'none'
          );
        }
      }
    });

    $('.topbar__submenu-list-item:last-child').on('focusout', function () {
      let bentoFocus = document.getElementById('wholeGameSystem');
      bentoFocus?.focus();
    });
  }

  loadScripts(script: any) {
    document.head.appendChild(script);
  }

  addEvents() {
    var that = this;
    if (document.getElementsByClassName('fa-navigation__header').length == 0) {
      $('.fa-navigation').prepend(this.htmlContent.mobileContent);
    }
    if (
      document.getElementsByClassName('global-navigation container').length == 0
    ) {
      $('.navigation-holder').prepend(this.htmlContent.subHeader);
      $('.global-navigation__primary-list-item').on({
        mouseenter: function () {
          $(this).addClass('menu-active');
        },
        mouseleave: function () {
          $(this).removeClass('menu-active');
        },
      });
    }
    $('.topbar__link.more-content').on({
      'mouseenter': that.setMouseEnter.bind(this),
      'mouseleave': that.setMouseLeave.bind(this)
    });

    $('.topbar__submenu-primary').on({
      'mouseenter': that.setMouseEnter.bind(this),
      'mouseleave': that.setMouseLeave.bind(this)
    });

    $('.topbar__submenu-list-item').on({
      mouseenter: function () {
        $(this).find('a').first().css('color', '#205184');
        $(this).find('a').first().css('text-decoration', 'underline');
        $(this)
          .find('.topbar__submenu-list-items-secondary')
          .css('display', 'block');
        $(this)
          .parent()
          .children()
          .on(
            'mouseenter',
            function () {
              $(this)
                .find('.topbar__submenu-list-items-secondary')
                .css('display', 'block');
            }
            // function () {
            //   $(this).find('.topbar__submenu-list-items-secondary').css("display", "none");
            // }
          );
      },
      mouseleave: function () {
        $(this)
          .find('.topbar__submenu-list-items-secondary')
          .css('display', 'none');
        $(this).find('a').first().css('color', '#fff');
        $(this).find('a').first().css('text-decoration', 'none');
      },
    });
    $('.topbar__submenu-list-items-secondary').on(
      'mouseenter mouseleave',
      function () {
        $(this).css('color', '#fff');
        $(this).css('text-decoration', 'none');
      }
    );

    $('.menu-icon').on('click', function (e) {
      e.preventDefault();
      let menuIexpanded = document.getElementsByClassName('menu-icon');
      if (that.menuactive)
        menuIexpanded[0].setAttribute('aria-expanded', 'false');
      else menuIexpanded[0].setAttribute('aria-expanded', 'true');
      that.menuactive = !that.menuactive;
      $('.fa-navigation').toggleClass('fa-navigation--active', that.menuactive);
      $('.more-content:not(.extramenu__social-dropdown)').on(
        'click',
        function (evt) {
          evt.preventDefault();
          $(this).next().addClass('topbar__submenu--active');
        }
      );
      $('.topbar__return-button').on('click', function (ev) {
        ev.preventDefault();
        $(this)
          .closest('.topbar__submenu')
          .removeClass('topbar__submenu--active');
      });
    });

    $('.menu-icon').on('focusout', function () {
      let active = document.getElementsByClassName('fa-navigation--active');
      if (active.length == 0) {
        let contentFocus: any =
          document.getElementsByClassName('current-page-title');
        contentFocus['0']?.focus();
      }
    });
    $('.topbar__link.more-content').on('focusout', function () {
      let contentFocus: any = document.getElementsByClassName('menu-icon');
      contentFocus['0']?.focus();
    });
  }

  setSubMenuStyle(displayStyle: string) {
    $('.fa-navigation .bentomenu .topbar__submenu-list-items').css(
      'display',
      displayStyle
    );
  }

  setMouseEnter(){
      $(
        '.fa-navigation .topbar__submenu:not(.topbar__submenu-list-items-secondary)'
      ).css('display', 'block');
      $('.topbar__link .more-content')
        .parent()
        .children()
        .on(
          'mouseenter',
          this.setSubMenuStyle.bind(this, 'block'),
          
          function () {
            $('.fa-navigation .topbar__submenu').css('display', 'none');
          }
        );
  }

  setMouseLeave(){
      $('.fa-navigation .topbar__submenu').css('display', 'none');
  }  
 
  onDataClick(event: Event) {
   
    this.targetLink = (<HTMLInputElement>event.target).getAttribute(
      'routerLink'
    );
   if(this.targetLink && this.targetLink.includes('diversityAndInclusion')){
    localStorage.setItem(
      "callingApp",
      'my-account'
    );
   }   
    let linkWithHash = window.location.hash;
    let tempArr = linkWithHash.split('#');
    if (tempArr && tempArr.length > 1) {
      this.currentLink = tempArr[1];
    } else {
      this.currentLink = linkWithHash;
    }

    if ((<HTMLInputElement>event.target).getAttribute('routerLink')) {
      (<HTMLInputElement>event.target).getAttribute('routerLink');

      if (
        !$(<HTMLInputElement>event.target)
          .closest('li.global-navigation__primary-list-item')
          .find('a')
          .hasClass('child-disable')
      ) {
        $(
          '.fa-navigation .global-navigation__primary-list-item .global-navigation__primary-link'
        ).removeAttr('aria-current');
        $(<HTMLInputElement>event.target)
          .closest('a.global-navigation__primary-link')
          .attr('aria-current', 'page');
        if (this.currentLink.includes('diversityAndInclusion')) {          
        //do something;
        } else {
          $('.fa-navigation .global-navigation__primary-list-item').removeClass(
            'current-section'
          );
          $(<HTMLInputElement>event.target)
            .closest('li.global-navigation__primary-list-item')
            .addClass('current-section');
          this.router.navigateByUrl('/' + this.targetLink).then(
            (nav1) => {
              
              this.menuactive = false;
              $('.fa-navigation').toggleClass(
                'fa-navigation--active',
                this.menuactive
              );
            },
            (err) => {
              
            }
          );
        }
      }
    }
    this.setLogoutClickHandler(event);  
  }

  setLogoutClickHandler(event:Event){
    
    if ((<HTMLInputElement>event.target).getAttribute('id') == 'logOut') {
      this.b2CUserAccountService.globalLogout().subscribe(()=>{
        this.router.navigateByUrl('account-management/logout');  
      })       
    }
    if ((<HTMLInputElement>event.target).tagName.toLowerCase() === 'span') {
      if (
        (<HTMLInputElement>event.target).parentElement?.getAttribute('id') ==
        'logOut'
      ) {
        this.b2CUserAccountService.globalLogout().subscribe(()=>{
          this.router.navigateByUrl('account-management/logout');
        })     
      }
    }
  }


}
